import { TableV2 } from '@anytag/shared-atoms';
import { SortAction, TableData } from '@anytag/shared-types';
import { InfluencerPostDetailsModal } from '@anytag/shared-molecules';
import { InfluencerSocialPost, PostListSortField, SocialPostType } from '@anytag/graphql';
import { useInfluencerXhsPostsListTable } from './hooks';

export interface InfluencerXhsPostsListProps extends TableData<InfluencerSocialPost>, SortAction<PostListSortField> {
  influencerId?: number;
  socialPostType: SocialPostType;
}

export const InfluencerXhsPostsList = ({
  sort,
  loading,
  setSort,
  data = [],
  influencerId,
  socialPostType
}: InfluencerXhsPostsListProps) => {
  const { columns } = useInfluencerXhsPostsListTable({ sort, setSort, socialPostType });

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="62px" noTopBorderRadius hasBorder />
      <InfluencerPostDetailsModal posts={data.map(({ id }) => ({ id: String(id), influencerId }))} />
    </>
  );
};
